import { render, staticRenderFns } from "./restFacilitiesDetail.vue?vue&type=template&id=750984e0"
import script from "./restFacilitiesDetail.vue?vue&type=script&lang=js"
export * from "./restFacilitiesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750984e0')) {
      api.createRecord('750984e0', component.options)
    } else {
      api.reload('750984e0', component.options)
    }
    module.hot.accept("./restFacilitiesDetail.vue?vue&type=template&id=750984e0", function () {
      api.rerender('750984e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rtf/restFacilitiesDetail.vue"
export default component.exports